import { Component } from '@angular/core';
import { NgbAlertModule, NgbCollapse, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SessionService } from '../../../Util/Session/session.service';

@Component({
  selector: 'app-tax-declaration-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, NgbDropdownModule, LoaderComponent, NgbCollapse, NgbDatepickerModule, NgbAlertModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './tax-declaration-form.component.html',
  styleUrl: './tax-declaration-form.component.scss'
})
export class TaxDeclarationFormComponent {
  isDisabled: boolean = false;
  isLoad: boolean = false;
  isEditAllow = false;
  IsDraft = false;
  FinancialYears: any[] = [];
  Message = null as any;
  ESS_EmpTaxDeclarationID = 0 as any;
  EmpMasterId = 0 as any;
  Detail = {
    SelectType: 'insert',
    ESS_EmpTaxDeclarationID: 0,
    IsNewRegime: false,
    EmpMasterId: null as any,
    //IncomeTaxFY: null as any,
    FinancialYearStart: null as any,
    FinancialYearEnd: null as any,
    IsLetOutProperty: false,
    IsHouseRented: false,
    ESS_TaxFinancialYearId: null,
    IsAdminEntry: false,
    IsTDSPaid: false,
    IsSelfOwnedProperty: false,
    ESS_TaxPreviousEmploymentDetails: [
      // {
      //   Monthname: null,
      //   Yearname: null as any,
      //   Remarks: null as any,
      //   Basic: null as any,
      //   DA: null as any,
      //   HRA: null as any,
      //   OtherAllowance: null as any,
      //   GrossAmount: 0,
      //   PT: null as any,
      //   PF: null as any,
      //   TDS: null as any,
      //   OtherDeduction: null as any,
      //   NetAmount: 0,
      //   TimeStamp: null,
      // }
    ] as any,
    ESS_EmpTaxDeclarationDetails: [{
      ESS_TaxSectionDetailId: null,
      ESS_TaxSubSectionFYMasterId: null,
      DeclaredAmount: null,
      ApprovedAmount: null as any,
      TimeStamp: null,
    }],
    ESS_EmpTaxDeclarationDetails_HRA: [{
      FromDate: null as any,
      ToDate: null as any,
      NameOfLandlord: null,
      LandLordPanNo: null,
      Address: null,
      IsMetroCity: false,
      DeclaredAmount: null,
      ApprovedAmount: null as any,
      TimeStamp: null,
    }],
    ESS_EmpTaxDeclarationDetails_Others: [{
      ESS_TaxSectionDetailId: null as any,
      ESS_TaxSubSectionFYMasterId: null as any,
      DeclaredAmount: null,
      ApprovedAmount: null,
      TimeStamp: null,
    }],
    ESS_EmpTaxDeclarationDetails_LOP: [{
      AnnualRentReceived: null as any,
      MunicipalTaxesPaid: null as any,//new
      NetAnnualValue: null as any,
      StandardDeduction: null as any,
      RepayingHomeLoanForThisProperty: false,
      PrincipalPaidOnHomeLoan: null as any,
      InterestPaidOnHomeLoan: null as any,//new
      NameOfTheLender: null as any,
      LenderPanNo: null as any,
      NetIncomeLossFromHouseProperty: null as any,
      TimeStamp: null,
    }],
    ESS_EmpTaxDeclarationDetails_TDS: [{
      TDSorTCSPaid: null,
      ChallanNo: null,
      PaymentDate: null as any,
      TimeStamp: null,
    }],
    ESS_EmpTaxDeclarationDetails_SOP: [{
      AnnualInterestPaidORPayable: null,
      PrincipalRepaymentAmount: null,
      LenderName: null,
      LenderPANNo: null,
      PropertyAddress: null,
      PossessionDate: null as any,
      CoOwnedProperty: false,
      CoOwnerName: null,
      CoOwnerSharePerc: null,
      TimeStamp: null,
    }],
  }

  OpenCard = {
    CardPreviousEmployment: false as any,
    CardEmpTaxDeclarationDetails: false as any,
    CardEmpTaxDeclarationDetails_HRA: false as any,
    CardEmpTaxDeclarationDetails_Others: false as any,
    CardEmpTaxDeclarationDetails_LOP: false as any,
    ESS_EmpTaxDeclarationDetails_TDS: false as any,
    ESS_EmpTaxDeclarationDetails_SOP: false as any,
  }

  MinDate = null as any;
  MaxDate = null as any;
  SectionDetails = [] as any;
  SectionDetailsOther = [] as any;
  Sections = [] as any;
  SectionsOther = [] as any;
  user = [] as any;

  UserDetails = {
    EmpMasterID: null,
    EmpCode: null,
    Name: null as any,
    Designation: null,
    Photo: null as any,
    PanNo: null,
    WorkStatus: null,
    LeftDate: null,
  }

  type = null;

  constructor(
    private toast: ToastService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private incometax: IncometaxService,
    private combo: ComboService,
    protected dateFormat: CustomDateParserFormatter,
    private router: Router,
    private session: SessionService,
    private route: ActivatedRoute,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    if (this.user.UserType == 'A') {
      this.route.params.subscribe(params => params['type'] == 'r' ? this.Detail.ESS_EmpTaxDeclarationID = parseInt(params['empid']) : this.Detail.EmpMasterId = parseInt(params['empid']));
    } else {
      this.route.params.subscribe(params => this.Detail.ESS_EmpTaxDeclarationID = parseInt(params['id']));
    }
    //this.route.params.subscribe(params => this.IsDraft = params['draft']);
  }

  ngOnInit(): void {
    this.ESS_EmpTaxDeclarationID = this.Detail.ESS_EmpTaxDeclarationID;
    this.EmpMasterId = this.Detail.EmpMasterId;

    if (this.user.UserType == 'A') {
      this.Detail.IsAdminEntry = true;
      this.isEditAllow = true;
      if (this.Detail.EmpMasterId > 0) {
        this.ComboLoad("FilterOnEmpCodeName");
      }
    }
    this.ESS_TaxFinancialYearSelect();
  }

  Validate(form: any) {
    if (form.valid) {
      if ((this.common.PageRight.IsAdd && this.Detail.ESS_EmpTaxDeclarationID == 0) || (this.common.PageRight.IsEdit && this.Detail.ESS_EmpTaxDeclarationID > 0)) {
        if (this.isEditAllow) {
          this.Detail.ESS_EmpTaxDeclarationDetails = [];
          this.Detail.ESS_EmpTaxDeclarationDetails_Others = [];

          this.SectionDetails.filter((e: any) => e.IsAdded && e.DeclaredAmount != null && e.DeclaredAmount != '' && e.DeclaredAmount > 0).forEach((element: any) => {
            this.Detail.ESS_EmpTaxDeclarationDetails.push(
              {
                ESS_TaxSectionDetailId: element.ESS_TaxSubSectionFYMasterID,
                ESS_TaxSubSectionFYMasterId: element.ESS_TaxSubSectionFYMasterID,
                DeclaredAmount: element.DeclaredAmount,
                ApprovedAmount: element.ApprovedAmount == undefined ? null : element.ApprovedAmount,
                TimeStamp: null,
              }
            );
          });

          this.SectionDetailsOther.filter((e: any) => e.IsAdded && e.DeclaredAmount != null && e.DeclaredAmount != '' && e.DeclaredAmount > 0).forEach((element: any) => {
            this.Detail.ESS_EmpTaxDeclarationDetails_Others.push(
              {
                ESS_TaxSectionDetailId: element.ESS_TaxSubSectionFYMasterID,
                ESS_TaxSubSectionFYMasterId: element.ESS_TaxSubSectionFYMasterID,
                DeclaredAmount: element.DeclaredAmount,
                ApprovedAmount: element.ApprovedAmount == undefined ? null : element.ApprovedAmount,
                TimeStamp: null,
              }
            );
          });
          this.ESS_EmpTaxDeclaration_InsertUpdate();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    } else {
      this.toast.show({ message: 'Please fill mandatory fields', type: toastTypeEnum.danger });
      form.submitted = true;
    }
  }

  // setYear(event: any, i: number) {
  //   if (this.Detail.ESS_TaxPreviousEmploymentDetails.filter(e => e.Monthname == event.Name && e.Yearname != null && e.Yearname != '').length == 0) {
  //     if (event.IsEndFinYear) {
  //       if (this.Detail.IncomeTaxFY != null && this.Detail.IncomeTaxFY != '') {
  //         this.Detail.ESS_TaxPreviousEmploymentDetails[i].Yearname = new Date(this.IncomeTax_FinancialYear.filter((e: any) => e.IncomeTaxFY == this.Detail.IncomeTaxFY)[0]['FinancialYearEnd']).getFullYear();
  //       }
  //     } else {
  //       if (this.Detail.IncomeTaxFY != null && this.Detail.IncomeTaxFY != '') {
  //         this.Detail.ESS_TaxPreviousEmploymentDetails[i].Yearname = new Date(this.IncomeTax_FinancialYear.filter((e: any) => e.IncomeTaxFY == this.Detail.IncomeTaxFY)[0]['FinancialYearStart']).getFullYear();
  //       }
  //     }
  //   } else {
  //     this.Delete(i, 'CardPreviousEmployment', false)
  //     this.toast.show({ message: "Month already selected", type: toastTypeEnum.dark });
  //   }
  // }

  Delete(i: number, cardname: string, IsPop = true) {
    if (IsPop) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to delete?';
      modalRef.result.then((result: any) => {
        if (result) {
          if (cardname == "CardPreviousEmployment") {
            this.Detail.ESS_TaxPreviousEmploymentDetails.splice(i, 1);
          } else if (cardname == "CardEmpTaxDeclarationDetails") {
            this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSectionDetailID == i)].IsAdded = false;
          } else if (cardname == "CardEmpTaxDeclarationDetails_HRA") {
            this.Detail.ESS_EmpTaxDeclarationDetails_HRA.splice(i, 1);
          } else if (cardname == "CardEmpTaxDeclarationDetails_Others") {
            this.SectionDetailsOther[this.SectionDetailsOther.findIndex((e: any) => e.ESS_TaxSectionDetailID == i)].IsAdded = false;
          } else if (cardname == "CardEmpTaxDeclarationDetails_LOP") {
            this.Detail.ESS_EmpTaxDeclarationDetails_LOP.splice(i, 1);
          } else if (cardname == "ESS_EmpTaxDeclarationDetails_TDS") {
            this.Detail.ESS_EmpTaxDeclarationDetails_TDS.splice(i, 1);
          } else if (cardname == "ESS_EmpTaxDeclarationDetails_SOP") {
            this.Detail.ESS_EmpTaxDeclarationDetails_SOP.splice(i, 1);
          }
        }
      });
    } else {
      if (cardname == "CardPreviousEmployment") {
        this.Detail.ESS_TaxPreviousEmploymentDetails.splice(i, 1);
      }
    }
  }

  Add(cardname: string, index = 0) {
    if (cardname == "CardPreviousEmployment") {
      this.Detail.ESS_TaxPreviousEmploymentDetails.push(
        {
          Monthname: null,
          Yearname: null as any,
          Remarks: null as any,
          Basic: null as any,
          DA: null as any,
          HRA: null as any,
          OtherAllowance: null as any,
          GrossAmount: 0,
          PT: null as any,
          PF: null as any,
          TDS: null as any,
          OtherDeduction: null as any,
          NetAmount: 0,
          TimeStamp: null,
        }
      );
    } else if (cardname == "CardEmpTaxDeclarationDetails") {
      this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSectionDetailID == this.Sections[index].ESS_TaxSectionMasterIDSelected)].IsAdded = true;
      this.Sections[index].ESS_TaxSectionMasterIDSelected = null;
      // if (this.Sections[index].SubSections == undefined || this.Sections[index].SubSections.length == 0) {
      //   this.Sections[index].SubSections = [];
      // }
      //this.Sections[index].SubSections.push(this.Sections[index].SubSections.filter((e:any) => e.ESS_TaxSectionDetailID == this.Sections[index].ESS_TaxSectionDetailIDSelected));
      // this.Detail.ESS_EmpTaxDeclarationDetails.push(
      //   {
      //     ESS_TaxSectionDetailId: null,
      //     DeclaredAmount: null,
      //     ApprovedAmount: null,
      //   });
    } else if (cardname == "CardEmpTaxDeclarationDetails_HRA") {
      this.Detail.ESS_EmpTaxDeclarationDetails_HRA.push(
        {
          FromDate: null,
          ToDate: null,
          NameOfLandlord: null,
          LandLordPanNo: null,
          Address: null,
          IsMetroCity: false,
          DeclaredAmount: null,
          ApprovedAmount: null as any,
          TimeStamp: null,
        });
    } else if (cardname == "CardEmpTaxDeclarationDetails_Others") {
      this.SectionDetailsOther[this.SectionDetailsOther.findIndex((e: any) => e.ESS_TaxSectionDetailID == this.SectionsOther[index].ESS_TaxSectionMasterIDSelected)].IsAdded = true;
      this.SectionsOther[index].ESS_TaxSectionMasterIDSelected = null;
      // this.Detail.ESS_EmpTaxDeclarationDetails_Others.push(
      //   {
      //     ESS_TaxSectionDetailId: null,
      //     DeclaredAmount: null,
      //     ApprovedAmount: null,
      //   });
    } else if (cardname == "CardEmpTaxDeclarationDetails_LOP") {
      this.Detail.ESS_EmpTaxDeclarationDetails_LOP.push(
        {
          AnnualRentReceived: null,
          MunicipalTaxesPaid: null,//new
          NetAnnualValue: null,
          StandardDeduction: null,
          RepayingHomeLoanForThisProperty: false,
          PrincipalPaidOnHomeLoan: null,
          InterestPaidOnHomeLoan: null,//new
          NameOfTheLender: null,
          LenderPanNo: null,
          NetIncomeLossFromHouseProperty: null,
          TimeStamp: null,
        });
    } else if (cardname == "ESS_EmpTaxDeclarationDetails_TDS") {
      this.Detail.ESS_EmpTaxDeclarationDetails_TDS.push(
        {
          TDSorTCSPaid: null,
          ChallanNo: null,
          PaymentDate: null,
          TimeStamp: null,
        });
    } else if (cardname == "ESS_EmpTaxDeclarationDetails_SOP") {
      this.Detail.ESS_EmpTaxDeclarationDetails_SOP.push({
        AnnualInterestPaidORPayable: null,
        PrincipalRepaymentAmount: null,
        LenderName: null,
        LenderPANNo: null,
        PropertyAddress: null,
        PossessionDate: null,
        CoOwnedProperty: false,
        CoOwnerName: null,
        CoOwnerSharePerc: null,
        TimeStamp: null,
      });
    }
  }

  onSwitchChange(event: any, cardname: string) {
    if (this.isLoad) {
      if (cardname == "CardPreviousEmployment") {
        this.OpenCard.CardPreviousEmployment = event.target.checked;
      } else if (cardname == "CardEmpTaxDeclarationDetails") {
        this.OpenCard.CardEmpTaxDeclarationDetails = event.target.checked;
      } else if (cardname == "CardEmpTaxDeclarationDetails_HRA") {
        this.OpenCard.CardEmpTaxDeclarationDetails_HRA = event.target.checked;
      } else if (cardname == "CardEmpTaxDeclarationDetails_Others") {
        this.OpenCard.CardEmpTaxDeclarationDetails_Others = event.target.checked;
      } else if (cardname == "CardEmpTaxDeclarationDetails_LOP") {
        this.OpenCard.CardEmpTaxDeclarationDetails_LOP = event.target.checked;
      } else if (cardname == "ESS_EmpTaxDeclarationDetails_TDS") {
        this.OpenCard.ESS_EmpTaxDeclarationDetails_TDS = event.target.checked;
      } else if (cardname == "ESS_EmpTaxDeclarationDetails_SOP") {
        this.OpenCard.ESS_EmpTaxDeclarationDetails_SOP = event.target.checked;
      }
    } else {
      this.OpenCard = {
        CardPreviousEmployment: false as any,
        CardEmpTaxDeclarationDetails: false as any,
        CardEmpTaxDeclarationDetails_HRA: false as any,
        CardEmpTaxDeclarationDetails_Others: false as any,
        CardEmpTaxDeclarationDetails_LOP: false as any,
        ESS_EmpTaxDeclarationDetails_TDS: false as any,
        ESS_EmpTaxDeclarationDetails_SOP: false as any,
      }
    }
  }

  CalcGross(index: number) {
    this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount = 0;
    this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount = 0;

    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].Basic != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].Basic != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].Basic > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].Basic);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].DA != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].DA != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].DA > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].DA);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].HRA != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].HRA != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].HRA > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].HRA);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherAllowance != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherAllowance != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherAllowance > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherAllowance);
    }

    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].PT != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].PT != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].PT > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].PT);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].PF != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].PF != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].PF > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].PF);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].TDS != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].TDS != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].TDS > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].TDS);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherDeduction != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherDeduction != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherDeduction > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherDeduction);
    }

    this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount = this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount - this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount;
  }

  CalcNet(index: number) {
    this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue = 0;
    this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].StandardDeduction = 0;
    this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty = 0;

    if (this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].AnnualRentReceived != null && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].AnnualRentReceived != '' && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].AnnualRentReceived > 0) {
      this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue += parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].AnnualRentReceived);
    }
    if (this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].MunicipalTaxesPaid != null && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].MunicipalTaxesPaid != '' && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].MunicipalTaxesPaid > 0) {
      this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue -= parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].MunicipalTaxesPaid);
    }

    this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty = parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue);

    if (this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue != null && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue != '' && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue > 0) {
      this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].StandardDeduction = (parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue) * 30) / 100;
      this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty = parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty) - parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].StandardDeduction);
    }

    if (this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].RepayingHomeLoanForThisProperty) {
      if (this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].PrincipalPaidOnHomeLoan != null && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].PrincipalPaidOnHomeLoan != '' && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].PrincipalPaidOnHomeLoan > 0) {
        this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty = parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty) - parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].PrincipalPaidOnHomeLoan);
      }
      if (this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].InterestPaidOnHomeLoan != null && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].InterestPaidOnHomeLoan != '' && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].InterestPaidOnHomeLoan > 0) {
        this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty = parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty) - parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].InterestPaidOnHomeLoan);
      }
    }
  }

  LoadDetails() {
    this.SectionDetails = [];
    this.SectionDetailsOther = [];
    if (this.Detail.ESS_TaxFinancialYearId != null && this.Detail.ESS_TaxFinancialYearId != '' && this.Detail.ESS_TaxFinancialYearId > 0) {
      if (!this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].PANValidationRequired
        || (this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].PANValidationRequired && this.UserDetails.PanNo != null && this.UserDetails.PanNo != '')) {
        this.Detail.FinancialYearStart = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].FinancialYearStart).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].FinancialYearStart).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].FinancialYearStart).getFullYear() });
        this.Detail.FinancialYearEnd = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].FinancialYearEnd).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].FinancialYearEnd).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].FinancialYearEnd).getFullYear() });

        this.MinDate = this.dateFormat.parse(this.Detail.FinancialYearStart);
        this.MaxDate = this.dateFormat.parse(this.Detail.FinancialYearEnd);

        if (!this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsDeclarationOpen) {
          if (!this.Detail.IsAdminEntry) {
            this.Message = 'The declaration has been locked, and Add/Edit is not allowed. kindly contact administrator';
            this.isEditAllow = false;
          }
        }
        this.ESS_EmpTaxDeclarationSelect();
      } else {
        const modalRef = this.modalService.open(AlertWarningComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = "PanNo not Available, kindly connect admin.";
        modalRef.result.then((result: any) => { });
      }
    } else {
      this.toast.show({ message: "Please financial year", type: toastTypeEnum.danger });
    }
  }

  TaxSectionDetail_SelectLoad(IncomeHead: any) {
    this.isDisabled = true;
    this.incometax.TaxSectionDetail_SelectLoad({ SelectType: 'S', ESS_TaxSectionDetailID: 0, ESS_TaxSectionMasterID: 0, FinancialYearFrom: this.Detail.FinancialYearStart, FinancialYearTo: this.Detail.FinancialYearEnd, IsNewRegime: this.Detail.IsNewRegime, IncomeHead: IncomeHead.value }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (this.common.ToLowerCase(IncomeHead.Name) == 'income from salary') {
            this.SectionDetails = response.Table.map((e: any) => ({ ...e, IsAdded: e.IsDefaultSubSection }));
            this.Detail.ESS_EmpTaxDeclarationDetails.forEach(element => {
              if (element.ESS_TaxSubSectionFYMasterId != null && element.ESS_TaxSubSectionFYMasterId != '' && element.ESS_TaxSubSectionFYMasterId > 0) {
                this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].DeclaredAmount = element.DeclaredAmount;
                this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].IsAdded = true;
                this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].ApprovedAmount = element.ApprovedAmount;
              }
            });
          } else if (this.common.ToLowerCase(IncomeHead.Name) == 'income from other sources') {
            this.SectionDetailsOther = response.Table.map((e: any) => ({ ...e, IsAdded: e.IsDefaultSubSection }));
            this.Detail.ESS_EmpTaxDeclarationDetails_Others.forEach(element => {
              if (element.ESS_TaxSubSectionFYMasterId != null && element.ESS_TaxSubSectionFYMasterId != '' && element.ESS_TaxSubSectionFYMasterId > 0) {
                this.SectionDetailsOther[this.SectionDetailsOther.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].DeclaredAmount = element.DeclaredAmount;
                this.SectionDetailsOther[this.SectionDetailsOther.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].IsAdded = true;
                this.SectionDetailsOther[this.SectionDetailsOther.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].ApprovedAmount = element.ApprovedAmount;
              }
            });
          }
        } else {
          this.SectionDetails = [];
          this.SectionDetailsOther = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Reset() {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to reset?';
    modalRef.componentInstance.Message2 = 'All data will reset!';
    modalRef.result.then((result: any) => {
      if (result) {
        this.isLoad = false;
        this.Message = null;
        this.Detail = {
          SelectType: 'insert',
          ESS_EmpTaxDeclarationID: 0,
          IsNewRegime: false,
          EmpMasterId: null,
          FinancialYearStart: null as any,
          FinancialYearEnd: null as any,
          IsLetOutProperty: false,
          IsHouseRented: false,
          ESS_TaxFinancialYearId: null,
          IsAdminEntry: this.Detail.IsAdminEntry,
          IsTDSPaid: false,
          IsSelfOwnedProperty: false,
          ESS_TaxPreviousEmploymentDetails: [
            // {
            //   Monthname: null,
            //   Yearname: null as any,
            //   Remarks: null as any,
            //   Basic: null as any,
            //   DA: null as any,
            //   HRA: null as any,
            //   OtherAllowance: null as any,
            //   GrossAmount: 0,
            //   PT: null as any,
            //   PF: null as any,
            //   TDS: null as any,
            //   OtherDeduction: null as any,
            //   NetAmount: 0,
            //   TimeStamp: null,
            // }
          ] as any,
          ESS_EmpTaxDeclarationDetails: [{
            ESS_TaxSectionDetailId: null,
            ESS_TaxSubSectionFYMasterId: null,
            DeclaredAmount: null,
            ApprovedAmount: null,
            TimeStamp: null,
          }],
          ESS_EmpTaxDeclarationDetails_HRA: [{
            FromDate: null,
            ToDate: null,
            NameOfLandlord: null,
            LandLordPanNo: null,
            Address: null,
            IsMetroCity: false,
            DeclaredAmount: null,
            ApprovedAmount: null,
            TimeStamp: null,
          }],
          ESS_EmpTaxDeclarationDetails_Others: [{
            ESS_TaxSectionDetailId: null,
            ESS_TaxSubSectionFYMasterId: null,
            DeclaredAmount: null,
            ApprovedAmount: null,
            TimeStamp: null,
          }],
          ESS_EmpTaxDeclarationDetails_LOP: [{
            AnnualRentReceived: null as any,
            MunicipalTaxesPaid: null as any,//new
            NetAnnualValue: null as any,
            StandardDeduction: null as any,
            RepayingHomeLoanForThisProperty: false,
            PrincipalPaidOnHomeLoan: null as any,
            InterestPaidOnHomeLoan: null as any,//new
            NameOfTheLender: null as any,
            LenderPanNo: null as any,
            NetIncomeLossFromHouseProperty: null as any,
            TimeStamp: null,
          }],
          ESS_EmpTaxDeclarationDetails_TDS: [{
            TDSorTCSPaid: null,
            ChallanNo: null,
            PaymentDate: null,
            TimeStamp: null,
          }],
          ESS_EmpTaxDeclarationDetails_SOP: [{
            AnnualInterestPaidORPayable: null,
            PrincipalRepaymentAmount: null,
            LenderName: null,
            LenderPANNo: null,
            PropertyAddress: null,
            PossessionDate: null,
            CoOwnedProperty: false,
            CoOwnerName: null,
            CoOwnerSharePerc: null,
            TimeStamp: null,
          }],
        }

        this.OpenCard = {
          CardPreviousEmployment: false as any,
          CardEmpTaxDeclarationDetails: false as any,
          CardEmpTaxDeclarationDetails_HRA: false as any,
          CardEmpTaxDeclarationDetails_Others: false as any,
          CardEmpTaxDeclarationDetails_LOP: false as any,
          ESS_EmpTaxDeclarationDetails_TDS: false as any,
          ESS_EmpTaxDeclarationDetails_SOP: false as any,
        }
      }
    });
  }

  async ESS_EmpTaxDeclaration_InsertUpdate() {
    this.isDisabled = true;

    if (this.user.UserType == 'E') {
      this.Detail.EmpMasterId = this.user.UserId;
    }

    if (this.user.UserType == 'A') {
      this.Detail.SelectType = 'insert';
    }

    this.Detail.ESS_EmpTaxDeclarationDetails_HRA.forEach((element: any) => {
      if (element.FromDate != "" && element.FromDate != null) {
        element.FromDate = this.dateFormat.format(element.FromDate);
      }
      if (element.ToDate != "" && element.ToDate != null) {
        element.ToDate = this.dateFormat.format(element.ToDate);
      }
    });

    this.Detail.ESS_EmpTaxDeclarationDetails_TDS.forEach((element: any) => {
      if (element.PaymentDate != "" && element.PaymentDate != null) {
        element.PaymentDate = this.dateFormat.format(element.PaymentDate);
      }
    });

    this.Detail.ESS_EmpTaxDeclarationDetails_SOP.forEach((element: any) => {
      if (element.PossessionDate != "" && element.PossessionDate != null) {
        element.PossessionDate = this.dateFormat.format(element.PossessionDate);
      }
    });

    this.incometax.ESS_EmpTaxDeclaration_InsertUpdate(this.Detail).subscribe({
      next: async (response) => {
        if (response.Error_Code == '690' || response.Error_Code == '721') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (this.user.UserType == 'A') {
              this.router.navigate(['/incometax/incometax/detail/d', response.OutputId]);
            } else {
              this.router.navigate(['/request/incometax/taxdeclaration/detail', response.OutputId]);
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {

            this.Detail.ESS_EmpTaxDeclarationDetails_HRA.forEach((element: any) => {
              if (element.FromDate != "" && element.FromDate != null) {
                element.FromDate = this.dateFormat.parse(element.FromDate);
              }
              if (element.ToDate != "" && element.ToDate != null) {
                element.ToDate = this.dateFormat.parse(element.ToDate);
              }
            });

            this.Detail.ESS_EmpTaxDeclarationDetails_TDS.forEach((element: any) => {
              if (element.PaymentDate != "" && element.PaymentDate != null) {
                element.PaymentDate = this.dateFormat.parse(element.PaymentDate);
              }
            });

            this.Detail.ESS_EmpTaxDeclarationDetails_SOP.forEach((element: any) => {
              if (element.PossessionDate != "" && element.PossessionDate != null) {
                element.PossessionDate = this.dateFormat.parse(element.PossessionDate);
              }
            });

          });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpTaxDeclarationSelect(IsRegimeSet = false) {
    this.isDisabled = true;
    if (this.user.UserType == 'A') {
      this.Detail.ESS_EmpTaxDeclarationID = this.ESS_EmpTaxDeclarationID;
      this.Detail.EmpMasterId = this.EmpMasterId;
    }

    this.incometax.ESS_EmpTaxDeclarationSelect({ SelectType: 'S', ESS_EmpTaxDeclarationID: this.Detail.ESS_EmpTaxDeclarationID, EmpMasterId: this.user.UserType == 'A' ? this.Detail.EmpMasterId : this.user.UserId, FinancialYearFrom: this.Detail.FinancialYearStart, FinancialYearTo: this.Detail.FinancialYearEnd, ApprovalStatus: this.user.UserType == 'A' ? 'Approved' : 'ALL' }).subscribe({
      next: (response) => {
        if (response) {
          if (response.Table && response.Table.length > 0) {
            if (this.user.UserType == 'A') {
              this.Detail.ESS_EmpTaxDeclarationID = 0;
            } else {
              this.Detail.SelectType = 'update';
            }
            //this.Detail.ESS_EmpTaxDeclarationID = response.Table[0].ESS_EmpTaxDeclarationID;
            if (IsRegimeSet) {
              this.Detail.IsNewRegime = response.Table[0].IsNewRegime;
            }

            this.Detail.EmpMasterId = response.Table[0].EmpMasterId;
            this.Detail.FinancialYearStart = response.Table[0].FinancialYearStart;
            this.Detail.FinancialYearEnd = response.Table[0].FinancialYearEnd;
            this.IsDraft = response.Table[0].IsDraft;
            //this.isEditAllow = (this.IsDraft || this.common.ToLowerCase(response.Table[0].ApprovalStatus) == 'rejected');
            this.isEditAllow = (this.IsDraft || (this.common.ToLowerCase(response.Table[0].ApprovalStatus) == 'approved' && this.Detail.ESS_EmpTaxDeclarationID == 0 && this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == response.Table[0].ESS_TaxFinancialYearID)[0].IsMultipleDeclarationAllowed));
            if (this.Detail.ESS_EmpTaxDeclarationID == 0) {
              this.Detail.SelectType = 'insert';
            }
            this.Detail.ESS_TaxFinancialYearId = response.Table[0].ESS_TaxFinancialYearID;
            if (this.isEditAllow) {
              if (response.Table2) {
                this.Detail.ESS_TaxPreviousEmploymentDetails = response.Table2;
              }

              if (response.Table1) {
                this.Detail.ESS_EmpTaxDeclarationDetails = response.Table1;
              }

              if (response.Table3) {
                this.Detail.ESS_EmpTaxDeclarationDetails_HRA = response.Table3;
                this.Detail.ESS_EmpTaxDeclarationDetails_HRA.forEach(element => {
                  if (element.FromDate != null && element.FromDate != '') {
                    element.FromDate = this.dateFormat.parse(element.FromDate);
                  }
                  if (element.ToDate != null && element.ToDate != '') {
                    element.ToDate = this.dateFormat.parse(element.ToDate);
                  }
                });
                this.Detail.IsHouseRented = true;
              }

              if (response.Table4) {
                this.Detail.ESS_EmpTaxDeclarationDetails_Others = response.Table4;
              }

              if (response.Table5) {
                this.Detail.ESS_EmpTaxDeclarationDetails_LOP = response.Table5;
                this.Detail.IsLetOutProperty = true;
              }

              if (response.Table6) {
                this.Detail.ESS_EmpTaxDeclarationDetails_TDS = response.Table6;
                this.Detail.ESS_EmpTaxDeclarationDetails_TDS.forEach(element => {
                  if (element.PaymentDate != null && element.PaymentDate != '') {
                    element.PaymentDate = this.dateFormat.parse(element.PaymentDate);
                  }
                });
                this.Detail.IsTDSPaid = true;
              }

              if (response.Table7) {
                this.Detail.ESS_EmpTaxDeclarationDetails_SOP = response.Table7;
                this.Detail.ESS_EmpTaxDeclarationDetails_SOP.forEach(element => {
                  if (element.PossessionDate != null && element.PossessionDate != '') {
                    element.PossessionDate = this.dateFormat.parse(element.PossessionDate);
                  }
                });
                this.Detail.IsSelfOwnedProperty = true;
              }

              if (this.user.UserType == 'A' && this.Detail.EmpMasterId > 0) {
                this.ComboLoad("FilterOnEmpCodeName");
              }
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = "Multiple declaration not allowed.";
              modalRef.result.then((result: any) => {
                if (this.user.UserType == 'A') {
                  this.router.navigate(['/incometax/incometax/detail/d/', + response.Table[0].ESS_EmpTaxDeclarationID]);
                } else {
                  this.router.navigate(['/request/incometax/taxdeclaration/detail/' + response.Table[0].ESS_EmpTaxDeclarationID]);
                }
              });
            }
          }
          this.TaxSectionMasterSelectLoad();
          //this.ComboLoad('IncomeTaxHead');
          this.TaxSectionDetail_SelectLoad({ "Name": "Income From Salary", "value": "Income From Salary" });
          this.TaxSectionDetail_SelectLoad({ "Name": "Income From Other Sources", "value": "Income From Other Sources" });
          this.isLoad = true;

          this.OpenCard = {
            CardPreviousEmployment: true as any,
            CardEmpTaxDeclarationDetails: true as any,
            CardEmpTaxDeclarationDetails_HRA: true as any,
            CardEmpTaxDeclarationDetails_Others: true as any,
            CardEmpTaxDeclarationDetails_LOP: true as any,
            ESS_EmpTaxDeclarationDetails_TDS: true as any,
            ESS_EmpTaxDeclarationDetails_SOP: true as any,
          }

          if (this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsDeclarationOpen == 0
            || (response.Table && response.Table.length > 0 && !this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsMultipleDeclarationAllowed && response.Table[0].ESS_EmpTaxDeclarationID > 0)) {
            if (!this.Detail.IsAdminEntry) {
              this.isEditAllow = false;
              if (this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsDeclarationOpen == 0) {
                this.Message = 'The declaration has been locked, and Add/Edit is not allowed. kindly contact administrator';
              }
            }
          } else {
            this.isEditAllow = true;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  TaxSectionMasterSelectLoad() {
    this.isDisabled = true;
    this.incometax.TaxSectionMasterSelectLoad({ SelectType: 'S', ESS_TaxSectionMasterID: 0, FinancialYearFrom: this.Detail.FinancialYearStart, FinancialYearTo: this.Detail.FinancialYearEnd }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Sections = response.Table.map((e: any) => ({ ...e, ESS_TaxSectionMasterIDSelected: null }));
          this.SectionsOther = response.Table.map((e: any) => ({ ...e, ESS_TaxSectionMasterIDSelected: null }));
        } else {
          this.Sections = [];
          this.SectionsOther = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  filterSubSection(sectionid: number, IsDefaultSubSection: any, IsDefaultSubSectionCheck: boolean, IsFromOther: boolean): [] {
    if (IsDefaultSubSectionCheck) {
      if (!IsFromOther) {
        return this.SectionDetails.filter((e: any) => e.ESS_TaxSectionMasterId == sectionid && (IsDefaultSubSection == null || e.IsAdded == IsDefaultSubSection));
      } else {
        return this.SectionDetailsOther.filter((e: any) => e.ESS_TaxSectionMasterId == sectionid && (IsDefaultSubSection == null || e.IsAdded == IsDefaultSubSection));
      }
    } else {
      if (!IsFromOther) {
        return this.SectionDetails.filter((e: any) => e.ESS_TaxSectionMasterId == sectionid);
      } else {
        return this.SectionDetailsOther.filter((e: any) => e.ESS_TaxSectionMasterId == sectionid);
      }
    }
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'EmpMasterID': Combotype == 'FilterOnEmpCodeName' ? this.Detail.EmpMasterId : this.user.UserId }).subscribe({
      next: (response) => {
        if (Combotype == 'IncomeTaxHead') {
          response.ComboLoad.forEach((element: any) => {
            this.TaxSectionDetail_SelectLoad(element)
          });
        } else if (Combotype == 'FilterOnEmpCodeName') {
          this.UserDetails = response.ComboLoad[0];
        }
        this.isDisabled = false;
      },
      complete: () => {
        // if (this.Detail.ESS_EmpTaxDeclarationID > 0) {
        //   if (Combotype == 'IncomeTax_FinancialYear') {
        //     this.ESS_EmpTaxDeclarationSelect();
        //   }
        // } else {
        //   this.isEditAllow = true;
        // }
        // if (this.Detail.ESS_EmpTaxDeclarationID == 0) {
        //   this.isEditAllow = true;
        // }
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_TaxFinancialYearSelect() {
    this.isDisabled = true;
    this.incometax.ESS_TaxFinancialYearSelect({ SelectType: 'S', ESS_TaxFinancialYearID: null, FinancialYearFrom: null, FinancialYearTo: null }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.FinancialYears = response.Table.filter((e: any) => e.IsActive);
          this.FinancialYears.forEach(element => {
            element.FinancialYear = new Date(element.FinancialYearStart).getFullYear() + ' - ' + new Date(element.FinancialYearEnd).getFullYear();
          });
        } else {
          this.FinancialYears = [];
        }
        this.isDisabled = false;
      },
      complete: () => {
        if (this.Detail.ESS_EmpTaxDeclarationID > 0) {
          this.ESS_EmpTaxDeclarationSelect(true);
        }
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  changeFinancialYear(): string | null {
    if (!this.Detail?.ESS_TaxFinancialYearId) return null;

    const financialYear = this.FinancialYears.find(
      e => e.ESS_TaxFinancialYearID === this.Detail.ESS_TaxFinancialYearId
    );
    return financialYear?.LastDateForDeclarationSubmission || null;
  }

  setRegime() {
    if (this.Detail.ESS_TaxFinancialYearId != null && this.Detail.ESS_TaxFinancialYearId > 0) {
      this.Detail.IsNewRegime = this.common.ToLowerCase(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].DefaultRegimeSelection) == 'n';
    }
  }

  Cancel() {
    if (this.user.UserType == 'A') {
      this.router.navigate(['/incometax/incometax/']);
    } else {
      this.router.navigate(['/request/incometax/taxdeclaration/']);
    }
  }
}
